import router from './router'


const title = process.env.VUE_APP_TITLE || 'APP';

const getPageTitle = function (pageTitle) {
  if (pageTitle) {
    return `${title} - ${pageTitle}`
  }
  return `${title}`
}



//全局前置守卫 
router.beforeEach(async (to, from, next) => {

  console.log('[当前页面路径] ' + to.path);
  // set page title
  document.title = getPageTitle(to.meta.title)

  next()

})